import { useGetCorrections } from '@/api/corrections/GetCorrections'
import ApprovedStatus from '@/components/forms/final-toast/ApprovedStatus'
import RejectedStatus from '@/components/forms/final-toast/RejectedStatus'
import PendingStatus from '@/components/forms/final-toast/PendingStatus'
import { EUserStatus } from '@/types/register-status'

const RegisterStatus = () => {
  const { data } = useGetCorrections({})

  if (!data) return null

  const renderStatusComp = () => {
    if (data.status === EUserStatus.REJECTED) {
      return <RejectedStatus data={data} />
    } else if (data.status === EUserStatus.APPROVED) {
      return <ApprovedStatus data={data} />
    } else {
      return <PendingStatus data={data} />
    }
  }

  return (
    <div className="flex items-center h-full justify-center bg-gray-100">
      {renderStatusComp()}
    </div>
  )
}

export default RegisterStatus
